export default "__VITE_ASSET__ee16d591__"